import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import api from '@common/utils/api';
import '@moncler/scss/components/hero-simplified/component-hero-simplified.scss';
import HeroColumnGenius from './HeroColumnGenius';
const HeroGenius = (props) => {
    const [componentData, setComponentData] = useState(null);
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                setComponentData(componentDataRes);
            });
        }
    }, []);
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    let { data } = componentData;
    let wrapperData = {
        imageRatio: '',
        countdown_active: data.countdown_active,
        stickyContent: data.sticky_content,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('hero genius hero--genius', { 'hero--without-border': data.borders === 'Without' }, { 'hero--with-border': data.borders === 'With' }, `gradient-${data.gradientStrength}`) },
            React.createElement(HeroColumnGenius, { slide: componentData, data: wrapperData, isStandalone: true }))));
};
export default HeroGenius;
